import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';
import { NavLink } from 'react-router-dom';

export default class Referral extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: props.Id,
            data: null,
            loading: true
        }
    }
    componentDidMount() {
        this.httpPost("api/v1/profile/getreferrals", {
            id: this.getCurrentFormId()
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    renderForm() {
        return <div className="nk-content ">
            <div className="container-fluid">
                <div className="nk-content-inner">
                    <div className="nk-content-body">
                        <div className="components-preview wide-md mx-auto">
                            <div className="nk-block nk-block-lg">
                                <div className="card card-bordered">
                                    <div className="card-inner">
                                        <div className="alert alert-fill alert-info alert-icon">
                                            <em className="icon ni ni-alert-circle"></em> شما میتوانید به وسیله لینک زیر دوستان خود را به سامانه دعوت کنید و کسب درآمد نمایید
                                            <br />
                                            <p className="ltr text-left font-bold">https://panel.domain.com/register?ref={this.state.data.global.user.id}</p>
                                            <a className="btn btn-lg btn-success" onClick={e=>this.copyToClipboard("https://panel.domain.com/register?ref=" + this.state.data.global.user.id)}>کپی لینک</a>
                                        </div>

                                        <h5 className="mt-4 mb-2">فهرست دوستان دعوت شده شما</h5>
                                        {this.isEmpty(this.state.data.records) ?
                                            <div className="card-inner-group">
                                                <div className="example-alert">
                                                    <div className="alert alert-pro alert-warning">
                                                        <div className="alert-text">
                                                            <h6>توجه</h6>
                                                            <p>در حال حاضر هیچ دوستی ثبت نشده است</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            :
                                            <div className="card-inner-group">
                                                <div className="card-inner p-0">
                                                    <div className="nk-tb-list nk-tb-ulist">
                                                        <div className="nk-tb-item nk-tb-head">
                                                            <div className="nk-tb-col"><span className="sub-text">ردیف</span></div>
                                                            <div className="nk-tb-col"><span className="sub-text">نام و نام خانوادگی</span></div>
                                                            <div className="nk-tb-col tb-col-md"><span className="sub-text text-center">تاریخ ثبت</span></div>
                                                        </div>
                                                        {this.state.data.records.map((record, index) =>
                                                            <div className="nk-tb-item">
                                                                <div className="nk-tb-col">
                                                                    <span className="sub-text">{this.genRowNumber(index)}</span>
                                                                </div>
                                                                <div className="nk-tb-col">
                                                                    <span className="sub-text">{record.fName} {record.lName}</span>
                                                                </div>
                                                                <div className="nk-tb-col tb-col-md">
                                                                    <span className="sub-text text-center">{record.createDatePersian}</span>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />
            ];

        return contents;
    }
}